import { computed, inject, Injectable, signal } from '@angular/core';
import { SIDEMENU_CONFIG } from '@lib-ui/lib/tokens/sidemenu.config';

@Injectable({
  providedIn: 'root',
})
export class SidemenuService {
  private readonly config = inject(SIDEMENU_CONFIG);
  private readonly configState = signal(this.config);
  public menu = computed(() => this.configState().menuItems);
}
